import { useEffect, useState } from "react";
import api from "../../../lib/api";
import { PlantBadge } from "../../Bits";

export default function PlantCarouselBlock({ data }) {
  const { title, category, season, limit } = data || {};
  const [plants, setPlants] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const params = {};
    if (category && category !== "all") params.category = category;
    if (season && season !== "all" && Number(season) > 0) params.month = Number(season);
    params.limit = Number(limit) || 6;
    api
      .get("/plants", { params })
      .then((r) => setPlants((r.data || []).slice(0, params.limit)))
      .finally(() => setLoading(false));
  }, [category, season, limit]);

  if (loading) return <div className="py-12 text-center text-sm opacity-60">Lade Pflanzen …</div>;
  if (!plants.length) return null;

  return (
    <section className="py-12 md:py-16">
      <div className="max-w-7xl mx-auto px-6 md:px-8 lg:px-12">
        {title && (
          <h2 className="font-display text-3xl md:text-4xl mb-8 tracking-tight" style={{ color: "var(--wp-text)" }}>
            {title}
          </h2>
        )}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {plants.map((p) => (
            <a
              key={p.id}
              href={`/plants/${p.slug}`}
              className="plant-card overflow-hidden group block"
              data-testid={`carousel-plant-${p.slug}`}
            >
              {p.image_url && (
                <div className="aspect-[4/3] overflow-hidden">
                  <img
                    src={p.image_url}
                    alt={p.name_de}
                    className="w-full h-full object-cover transition-transform group-hover:scale-105"
                  />
                </div>
              )}
              <div className="p-5">
                <div className="flex items-center gap-2 mb-2">
                  <PlantBadge category={p.category} />
                </div>
                <h3 className="font-display text-xl mb-1" style={{ color: "var(--wp-olive)" }}>{p.name_de}</h3>
                <div className="text-xs italic opacity-70">{p.name_lat}</div>
                {p.description && (
                  <p className="text-sm mt-3 line-clamp-2" style={{ color: "var(--wp-text-muted)" }}>
                    {p.description}
                  </p>
                )}
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}
